import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Navigation } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Analyzing() {
  const { t } = useLang();
  const messages = [t("analyzing.1"), t("analyzing.2"), t("analyzing.3"), t("analyzing.4")];
  const [i, setI] = useState(0);
  useEffect(() => {
    const tm = setInterval(() => setI((x) => (x + 1) % 4), 1600);
    return () => clearInterval(tm);
  }, []);
  return (
    <div className="flex min-h-[65vh] flex-col items-center justify-center text-center">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 3.5, ease: "linear" }}
        className="flex h-16 w-16 items-center justify-center rounded-2xl border border-decide-line bg-decide-surface"
      >
        <Navigation size={26} className="text-decide-forest" style={{ transform: "rotate(45deg)" }} fill="#2C4C3B" fillOpacity={0.12} />
      </motion.div>
      <div className="mt-8 h-6 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.p key={i} data-testid="analyzing-message" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.4 }} className="text-decide-ink font-medium">
            {messages[i]}
          </motion.p>
        </AnimatePresence>
      </div>
      <div className="mt-6 h-1 w-40 overflow-hidden rounded-full bg-decide-line">
        <motion.div className="h-full bg-decide-forest" initial={{ x: "-100%" }} animate={{ x: "100%" }} transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }} style={{ width: "60%" }} />
      </div>
    </div>
  );
}
